<template>
    <div class="my-tcinfo">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div style="margin-top: -8px">
            <van-tabs v-model="active">
                <van-tab title="日常消费">
                    <div style="background-color: #EEEEEE">
                        <van-list
                                v-model="rcLoading"
                                :finished="rcFinished"
                                finished-text="没有更多了"
                                @load="rcLoad"
                        >
                            <div class="tc-items" v-for="item in rcList" @click="toDetails(item.id,item.deptName)">
                                <div style="background-color: #ffffff;padding: 15px">
                                    <div style="font-size: 13px;border-bottom: #EEEEEE solid 1px;padding-bottom: 5px">
                                        <span class="daodian">到店</span><span>{{item.deptName}}</span>
                                    </div>
                                    <div class="tc-item">
                                        <div class="tcinfo" style="border-bottom: 10px">
                                            <span class="tci3">消费金额</span>
                                            <span class="tci3">消费时间</span>
                                        </div>
                                        <div class="tcinfo" style="margin-top: 8px">
                                            <span class="tci3">{{item.totalPrice}}</span>
                                            <span class="tci3">{{item.createTime}}</span>
                                        </div>
                                    </div>
                                    <div style="font-size: 12px;margin-top: 12px">获得积分: 0</div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-tab>
                <van-tab title="充值续卡">
                    <div style="background-color: #EEEEEE">
                        <van-list
                                v-model="czLoading"
                                :finished="czFinished"
                                finished-text="没有更多了"
                                @load="czLoad"
                        >
                            <div class="tc-items" v-for="item in czList">
                                <div style="background-color: #ffffff;padding: 15px">
                                    <div style="font-size: 13px;border-bottom: #EEEEEE solid 1px;padding-bottom: 5px">
                                        <span class="daodian">到店</span><span>{{item.deptName}}</span>
                                    </div>
                                    <div class="tc-item">
                                        <div class="tcinfo" style="border-bottom: 10px">
                                            <span class="tci3">
                                                <span v-if="item.orderType==2">办卡金额</span>
                                                <span v-if="item.orderType==3">充值金额</span>
                                            </span>
                                            <span class="tci3">
                                                <span v-if="item.orderType==2">办卡时间</span>
                                                <span v-if="item.orderType==3">充值时间</span>
                                            </span>
                                        </div>
                                        <div class="tcinfo" style="margin-top: 8px">
                                            <span class="tci3">{{item.totalPrice}}</span>
                                            <span class="tci3">{{item.createTime}}</span>
                                        </div>
                                    </div>
                                    <div style="font-size: 12px;margin-top: 12px">获得积分: 0</div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <van-popup v-model="show" position="right" style="width: 100%;height: 100%;background-color: #EEEEEE"
                   :overlay="true">
            <div class="popupcss">
                <div class="xq-tou">
                    <span>订单详情</span>
                    <span @click="fanhui">返回</span>
                </div>
                <div class="xq-items">
                    <div style="background-color: #ffffff;padding: 13px;padding-bottom: 50px;">
                        <div style="font-size: 13px;border-bottom: #EEEEEE solid 1px;padding-bottom: 5px">
                            <span class="daodian">到店</span><span>{{deptName}}</span>
                        </div>
                        <div class="tc-item">
                            <div class="tcinfo" style="padding-bottom: 8px">
                                <span class="tci1">名称</span>
                                <span class="tci2">属性</span>
                                <span class="tci2">类型</span>
                                <span class="tci2">价格</span>
                            </div>
                            <div class="tcinfo" style="margin-top: 8px;margin-bottom: 5px" v-for="item in orderInfos">
                                <span class="tci1">{{item.commodityName}}</span>
                                <div class="tci2">
                                    <span v-if="item.commodityType==0">
                                        <span v-if="item.commoditySign==0">项目</span>
                                        <span v-if="item.commoditySign!=0">套餐</span>
                                    </span>
                                    <span v-if="item.commodityType==1">卖品</span>
                                    <span v-if="item.commodityType==2">套餐</span>
                                    <span v-if="item.commodityType==3">开卡</span>
                                    <span v-if="item.commodityType==4">充值</span>
                                    <span v-if="item.commodityType==5">品项</span>
                                    <span v-if="item.commodityType==10">成品</span>
                                </div>
                                <div class="tci2">
                                    <span v-if="item.commodityType==0">
                                        <span v-if="item.commoditySign==0">消费</span>
                                        <span v-if="item.commoditySign!=0">消耗</span>
                                    </span>
                                    <span v-if="item.commodityType!=0">
                                        <span>消耗</span>
                                    </span>
                                </div>
                                <span class="tci2">{{item.price}}</span>
                            </div>
                        </div>
                        <div style="margin-top: 30px">
                            <div style="font-size: 12px;margin-top: 18px">结算金额: {{order.totalPrice}}</div>
                            <div style="font-size: 12px;margin-top: 18px">消费时间: {{order.createTime}}</div>
                            <div style="font-size: 12px;margin-top: 18px">支付方式:
                                <span v-if="order.payType==0">会员卡<span style="margin-left: 3px"
                                                                       v-if="mcName">( {{mcName}} )</span></span>
                                <span v-if="order.payType==1">赠送金<span style="margin-left: 3px"
                                                                       v-if="mcName">( {{mcName}} )</span></span>
                                <span v-if="order.payType==2">现金</span>
                                <span v-if="order.payType==3">微信</span>
                                <span v-if="order.payType==4">支付宝</span>
                                <span v-if="order.payType==5">美团</span>
                                <span v-if="order.payType==6">抖音</span>
                                <span v-if="order.payType==7">混合支付</span>
                                <span v-if="order.payType==8">欠款</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '消费记录',
                active: 0,
                deptId: '',
                token: '',
                miList: [],

                rcList: [],
                rcLoading: false,
                rcFinished: false,
                rcPage: 1,

                czList: [],
                czLoading: false,
                czFinished: false,
                czPage: 1,

                show: false,
                order: {},
                orderInfos: [],
                deptName: '',
                mcName: '',
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
        },
        methods: {
            async rcLoad() {
                let currentPage = this.rcPage || 1;
                let data = {
                    token: this.token,
                    odType: 'RC',
                    currentPage
                }
                let res = await this.$get("/spm/getSpmCmpPage", data)
                if (res.code == 200) {
                    const count =res.list.length
                    const newList =res.list
                    const list =this.rcList.concat(newList)
                    if (list.length<30){
                        this.rcList = this.quchong(list,"id")
                    }else {
                        this.rcList =list
                    }
                    this.rcPage=this.rcPage+1
                    this.rcLoading = false
                    if (count<10&&count==0){
                        this.rcFinished = true
                    }
                }else {
                    this.rcFinished = true
                }
            },

            async czLoad() {
                let currentPage = this.czPage || 1;
                let data = {
                    token: this.token,
                    odType: 'CZ',
                    currentPage
                }
                let res = await this.$get("/spm/getSpmCmpPage", data)
                if (res.code == 200) {
                    const count =res.list.length
                    const newList =res.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.czList = this.quchong(list,"id")
                    }else {
                        this.czList =list
                    }
                    this.czPage=this.czPage+1
                    this.czLoading = false
                    if (count<10&&count==0){
                        this.czFinished = true
                    }
                }else {
                    this.czFinished = true
                }
            },

            async toDetails(orderId, deptName) {
                this.deptName = deptName
                this.show = true
                let data = {
                    orderId: orderId,
                }
                let res = await this.$get("/spm/getMdOrderDetails", data)
                this.order = res.order
                this.mcName = res.mcName
                this.orderInfos = res.orderInfos
            },
            fanhui() {
                this.show = false
            },
            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },

            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-tcinfo {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .tc-items {
        width: 98%;
        margin: auto;
        border-bottom: 5px;
        background-color: #EEEEEE;
        padding-top: 5px;
    }

    .tc-item {
        margin-top: 8px;
        background-color: #F8F8F8;
        padding: 8px 12px;
        display: flex;
        flex-direction: column;
    }

    .tcinfo {
        display: flex;
        flex-direction: row;
        font-size: 12px;
    }

    .tci1 {
        width: 40%;
    }

    .tci2 {
        width: 20%;
    }
    .tci3 {
        width: 50%;
    }

    .daodian {
        margin-right: 5px;
        background-color: #174346;
        color: #ffffff;
        padding: 1px 2px;
        font-size: 10px;
    }

    .popupcss {
        width: 100%;
        height: 100%;
    }

    .xq-tou {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 15px;
        padding: 12px;
        background-color: #ffffff;
    }

    .xq-items {
        width: 98%;
        margin: auto;
        border-bottom: 5px;
        background-color: #EEEEEE;
        padding-top: 5px;
    }

</style>
